import React, { useState } from 'react';
import Vocal from '../Vocal/Vocal';
import CloseIcon from '@material-ui/icons/Close';



const Suggest = (props) => {
  const [result, setResult] = useState('')

  const _onVocalStart = () => {
    setResult('')
  }

  const _onVocalResult = (result) => {
    setResult(result)
  }

  return (
    <div className="mobile-duties__title d-flex flex-column">
      <h2>عنوان {props.name}</h2>
      <div className="mobile-duties__title--field">
        <div className="mobile-float-input d-flex">
          <div className="mobile-float-input__value" onClick={() => props.openFloat()}>
            <section className="d-flex" style={{ position: 'relative' }}>
              {
                props.tag ?
                  <div className="mobile-float-input__value--tag d-flex"
                    style={{ border: '1px solid' + props.tag.color, color: props.tag.color }}
                    onClick={() => props.deleteTag()}
                  >
                    <CloseIcon style={{ width: 17, height: 17, marginLeft: 5, color: props.tag.color }} />
                    {props.tag.name}
                  </div> : null}
              <Vocal />
            </section>


          </div>
          {/* <img src={mic} className="mic" /> */}
        </div>
        {
          props.float ?
            <div className="mobile-float-box d-flex flex-column">
              <div className="mobile-float-box__close" onClick={() => props.closeFloat()}>بستن لیست پیشنهادی</div>
              <div className="mobile-float-box__orders">
                {
                  props.orders.map(item => (
                    <div
                      className="mobile-float-box__orders--item d-flex"
                      style={props.tag && props.tag.name === item.name ? { backgroundColor: item.color + '11', border: '1px solid' + item.color + '77' } : { border: '1px solid' + item.color + '77' }}
                      onClick={() => props.setTag(item)} key={item.name}
                    >
                      <img src={item.icon} />
                      <div style={{ color: item.color }}>{item.name}</div>
                    </div>
                  ))
                }
                <div className="mobile-float-box__orders--item d-flex" style={{ color: '#00ff00', border: '1px solid #00ff00' }}>
                  <div style={{ color: '#00ff00' }}>ایجاد یک وظیفه</div>
                  <span style={{ color: '#00ff00' }}>+</span>
                </div>
              </div>
            </div> : null
        }
      </div>
    </div>
  );
}

export default Suggest;